import {ref} from "vue"
import {defineStore} from "pinia"
import type {CustomError} from "./types"
import {AnimationFileNameEnum} from "@/components/types"

export const useErrorStore = defineStore("error", () => {
  // state
  const activeError = ref<null | CustomError>(null)

  // getters

  // actions
  function setError({
    error,
    statusCode,
    errTitle,
    errText,
    animation,
  }: {
    error: string | Error
    statusCode?: number
    errTitle?: string
    errText?: string
    animation?: AnimationFileNameEnum
  }) {
    activeError.value = typeof error === "string" ? Error(error) : error
    activeError.value.errTitle = errTitle ?? ""
    activeError.value.errText = errText ?? ""
    activeError.value.statusCode = statusCode ?? 500
    activeError.value.animation = animation ?? AnimationFileNameEnum.failed
  }

  return {activeError, setError}
})
